import { useCallback, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { CartProvider, useCart } from "./og/cart";
import { LangProvider, useLang } from "./og/i18n";
import { Loader } from "./og/Loader";
import { Nav } from "./og/Nav";
import { Marquee } from "./og/Marquee";
import { CartDrawer } from "./og/CartDrawer";
import { Footer } from "./og/Footer";
import Home from "./pages/Home";
import CollectionPage from "./pages/CollectionPage";
import ProductPage from "./pages/ProductPage";


const useLenis = () => {
  const { open } = useCart();
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);
  useEffect(() => {
    if (!window.__lenis) return;
    if (open) window.__lenis.stop(); else window.__lenis.start();
  }, [open]);
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
};

const Store = () => {
  const [ready, setReady] = useState(false);
  const done = useCallback(() => setReady(true), []);
  useLenis();
  const { t } = useLang();
  const top = ["WELCOME TO OFF GRID", t("top.pre"), "WELCOME TO OFF GRID", t("top.ship")];
  return (
    <div className="og-root bg-[#050505] text-[#F5F5F7]">
      <Loader onDone={done} />
      <div className="fixed top-0 inset-x-0 z-50">
        <Marquee testid="top-marquee" items={top} variant="red" speed={28} />
      </div>
      <Nav />
      <Routes>
        <Route path="/" element={<Home ready={ready} />} />
        <Route path="/collections/:handle" element={<CollectionPage />} />
        <Route path="/products/:id" element={<ProductPage />} />
        <Route path="*" element={<Home ready={ready} />} />
      </Routes>
      <Footer />
      <CartDrawer />
      <div className="og-grain" aria-hidden />
    </div>
  );
};

export default function App() {
  return (
    <LangProvider>
    <CartProvider>
      <BrowserRouter>
        <Store />
      </BrowserRouter>
      <Toaster
        position="bottom-left"
        theme="dark"
        toastOptions={{ style: { background: "#050505", color: "#F5F5F7", border: "1px solid #FF2A2A", borderRadius: 0, fontFamily: "JetBrains Mono, monospace" } }}
      />
    </CartProvider>
    </LangProvider>
  );
}
